import { render, staticRenderFns } from "./ReportPreExistingDamageDetailsTimeLineElement.vue?vue&type=template&id=6e641020&"
import script from "./ReportPreExistingDamageDetailsTimeLineElement.vue?vue&type=script&lang=ts&"
export * from "./ReportPreExistingDamageDetailsTimeLineElement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VTimelineItem } from 'vuetify/lib/components/VTimeline';
installComponents(component, {VCard,VTimelineItem})
